// extracted by mini-css-extract-plugin
export default {"card":"simple-card-module__card___an5Jk","card--no-shadow":"simple-card-module__card--no-shadow___gSKfc","card--outline":"simple-card-module__card--outline___ag4uL"};